import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';
const OPTION_ID = 'optionID';
const DEFAULT_COMPONENT_NAME = 'Component';

export class ComponentHolder extends React.Component {
  onDrop = (event) => {
    const optionID = parseInt(event.dataTransfer.getData(OPTION_ID));
    this.props.onDrop({
      optionID,
      positionId: this.props.positionId,
    });
  };

  onDragOver = (event) => {
    event.preventDefault();
  };
  getComponentName = () => {
    if (this.props.componentName) {
      return this.props.componentName;
    } else {
      return DEFAULT_COMPONENT_NAME;
    }
  };

  fullWidthCard = () => {
    return (
      <div
        className='full-width-card'
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}>
        + Add {this.getComponentName()}
      </div>
    );
  };

  linkHexagonModal = () => {
    return (
      <div
        className='link-hexagon-modal'
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}>
        + Add {this.getComponentName()}
      </div>
    );
  };

  render() {
    switch (this.props.type) {
      case COMPONENT_TYPE.FULL_WIDTH_CARD:
        return this.fullWidthCard();
      case COMPONENT_TYPE.LINK_HEXAGON_MODAL:
        return this.linkHexagonModal();
      default:
        return null;
    }
  }
}

ComponentHolder.propTypes = {
  type: PropTypes.string,
  positionId: PropTypes.number,
  onDrop: PropTypes.func,
  componentName: PropTypes.string,
};
